<template>
  <LISASelect
    v-model="selectedOptionId"
    class="w-100"
    hide-label
    :options="options"
    :placeholder="t('global.all')"
  />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useTranslation } from "@/language/translation";
import { LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import { SQDCBoardEventStatus } from "@/graphql";
import BoardOriginFilter from "../filterImplementations/BoardOriginFilter";
import { FilterUIProps } from "../FilterTypes";

defineProps(FilterUIProps);

const selectedOptionId = ref<number>();
const { t } = useTranslation();

const boardOriginOptions = computed(() => [
  {
    value: SQDCBoardEventStatus.ESCALATED,
    label: t("components.event-action.issue.BoardOriginArrow.escalated"),
  },
  {
    value: SQDCBoardEventStatus.DELEGATED,
    label: t("components.event-action.issue.BoardOriginArrow.delegated"),
  },
  {
    value: SQDCBoardEventStatus.CREATED,
    label: t("components.event-action.issue.BoardOriginArrow.created"),
  },
]);
const options = computed<LISASelectOption[]>(() =>
  boardOriginOptions.value.map((option, id) => ({ id, label: option.label })),
);

function getFilter() {
  const boardOrigin = boardOriginOptions.value[selectedOptionId.value ?? -1]?.value;
  return boardOrigin == null ? null : new BoardOriginFilter(boardOrigin);
}
function applyFilter(filter: BoardOriginFilter) {
  const index = boardOriginOptions.value.findIndex((option) => option.value === filter.boardOrigin);
  selectedOptionId.value = index < 0 ? undefined : index;
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>

<style lang="scss" scoped></style>
